import { SUPPORTED_CC } from '@trip-ux/constants';
import { has, reduce } from 'lodash';
import { CC_NUMBER, PAYMENT_METHOD, TravellerPayment } from './types';
import { checkTrue } from '@trip-ux/common';

export const hasAllTokenCheck = (act: TravellerPayment, rest: { [paxId: number]: TravellerPayment }): boolean => {
  return reduce(
    rest,
    (res, val) => {
      if (res) {
        if (
          val.paxId === act.paxId &&
          (act.paymentMethod === PAYMENT_METHOD.PAID_TO_AGENCY ||
            (act.paymentMethod === PAYMENT_METHOD.CREDIT_CARD && has(act, 'token')))
        ) {
          return true;
        } else {
          return (
            val.paymentMethod === PAYMENT_METHOD.PAID_TO_AGENCY ||
            (val.paymentMethod === PAYMENT_METHOD.CREDIT_CARD && has(val, 'token'))
          );
        }
      } else {
        return false;
      }
    },
    true
  );
};

const VISA_INDEX = 0;
const MASTER_INDEX = 1;
const AMEX_INDEX = 2;
export const setCcType = tokenNumber => {
  switch (tokenNumber?.[0]) {
    case CC_NUMBER.VISA:
      return SUPPORTED_CC[VISA_INDEX];
    case CC_NUMBER.MASTER:
      return SUPPORTED_CC[MASTER_INDEX];
    case CC_NUMBER.AMEX:
      return SUPPORTED_CC[AMEX_INDEX];
    default:
      return null;
  }
};

export const getPaymentMethod = formVal =>
  checkTrue(formVal) ? PAYMENT_METHOD.PAID_TO_AGENCY : PAYMENT_METHOD.CREDIT_CARD;
